module.exports = __webpack_public_path__ + "static/media/textProduct_DataDrivenPublishing.20c0e0d8.md";